import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  cpf: Yup.string().cpf(),
  cnpj: Yup.string().cpfCnpj(),
  senha: Yup.string().required(mensagemPadrao)
})
